import Stack from "@mui/material/Stack";
import { TEXT_BLOCK_DESCRIPTION_LIMIT } from "entities/modules/constants";
import { useGeneralData } from "modules/contentSchedule/components/ModuleDetailsDrawer/stores/useGeneralData";
import React, { type FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import { SelectOption } from "shared/components/Form/Select";
import TextField from "shared/components/Form/TextField";
import UploadImageField from "shared/components/Form/UploadImageField";
import { COLOR_BLACK } from "shared/theme/colors";
import { useContentScheduleModuleDetails } from "../../../../../../context";
import { StyledContainer, StyledRowContainer } from "./styled";

const TopPrivacyTipsSection: FC = () => {
  const { topPrivacyTipsBlockImageLoadingQuery } =
    useContentScheduleModuleDetails();
  const {
    topPrivacyTipsBlock,
    setTopPrivacyTipsBlock,
    topPrivacyTipsBlockImage,
    setTopPrivacyTipBlockImage,
  } = useGeneralData();

  const onChange = (
    value: string | boolean | SelectOption | File | null,
    field: string,
  ) => {
    setTopPrivacyTipsBlock({
      ...topPrivacyTipsBlock,
      [field]: value,
    });
  };

  const onChangeImage = (file: File | null) => {
    setTopPrivacyTipBlockImage(file);
  };

  if (!topPrivacyTipsBlock) {
    return null;
  }

  return (
    <ContentSection title="Module Configuration">
      <Stack spacing="1.5rem">
        <StyledContainer>
          <TextField
            id={"title"}
            label="Title*"
            placeholder="Click here to edit text"
            fullWidth
            required
            value={topPrivacyTipsBlock.title}
            onChange={(event) => onChange(event.target.value, "title")}
            labelColor={COLOR_BLACK}
          />
          <TextField
            id={"description"}
            label="Description*"
            placeholder="Click here to edit text"
            fullWidth
            required
            multiline
            value={topPrivacyTipsBlock.description}
            onChange={(event) => onChange(event.target.value, "description")}
            charactersLimit={TEXT_BLOCK_DESCRIPTION_LIMIT}
            InputProps={{ minRows: 5 }}
            labelColor={COLOR_BLACK}
          />
          <UploadImageField
            imageFile={topPrivacyTipsBlockImage}
            setImageFile={onChangeImage}
            label="Upload image*"
            isLoading={topPrivacyTipsBlockImageLoadingQuery}
          />
          <StyledRowContainer>
            <TextField
              id={"cta-for-registered-user"}
              label="CTA for registered user*"
              placeholder="Click here to edit text"
              fullWidth
              required
              value={topPrivacyTipsBlock.ctaForRegisteredUser}
              onChange={(event) =>
                onChange(event.target.value, "ctaForRegisteredUser")
              }
              labelColor={COLOR_BLACK}
            />
            <TextField
              id="cta-for-unregistered-user"
              label="CTA for unregistered user*"
              placeholder="Click here to edit text"
              fullWidth
              required
              value={topPrivacyTipsBlock.ctaForUnRegisteredUser}
              onChange={(event) =>
                onChange(event.target.value, "ctaForUnRegisteredUser")
              }
              labelColor={COLOR_BLACK}
            />
          </StyledRowContainer>
        </StyledContainer>
      </Stack>
    </ContentSection>
  );
};

export default TopPrivacyTipsSection;
